import S from 'common/service/sanctuary';
import { compose, without, prop } from 'ramda';
import React from 'react';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import { defineMessages, injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { CollectionWrapper } from 'common/mdc/wrappers';
import Button from 'common/mdc/button';
import { StepperContent } from 'common/mdc/stepper';
import { SwitchField } from 'common/mdc/form';
import { ToolbarSection } from 'common/mdc/toolbar';
import { Pagination } from 'common/mdc/table';
import withMultiSelection from 'common/mdc/table/multiSelection';
import Form, { Error, DisplayField } from "common/mdc/form/index";
import TextField from "common/mdc/textfield/index";
import RadioField from 'common/mdc/form/radio';
import GroupPrimary from '@sma/components/group/primary';
import {Groups} from '@sma/page';
import {
  actions as groupsActions,
} from '@sma/store/group/groups';
import { actions as jobsActions } from "@sma/store/job/jobs";
import { validateMeterSerialInput } from '../validator';

export const STEP_ID = Symbol('refine-selection');

const messages = defineMessages({
  title: {
    id: 'jobCreate.title.step2',
    defaultMessage: 'Select Meters',
  },
  continue: {
    id: 'jobCreate.actions.continue2',
    defaultMessage: 'Continue',
  },
});

export const title = <FormattedMessage {...messages.title} />;

class Step2 extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectBy: "meterGroup",
      selectedGroup: null,
      meterSerialNums: null,
      isContinueDisabled: true,
      uiError: null,
    };

    this.validateMeters = this.validateMeters.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setSelectedGroup = this.setSelectedGroup.bind(this);
    this.proceed = this.proceed.bind(this);
    this.handleSelectByChange = this.handleSelectByChange.bind(this);

  }

  componentDidMount() {
    const { isMeterInvalid, resetMeterExistenceCheck, loadGroups } = this.props;

    if(isMeterInvalid === true){
      resetMeterExistenceCheck();
    }

    loadGroups();

    const { selectedGroupOrMeters } = this.props.newJobEntries || {};
    if(selectedGroupOrMeters !== null && Object.keys(selectedGroupOrMeters).length > 0){
      // if selected was group
      if(selectedGroupOrMeters.name !== undefined){
        this.setState({
          selectBy: "meterGroup",
          selectedGroup: selectedGroupOrMeters,
          isContinueDisabled: false,
        });
      }
      // if selected were meters
      if(selectedGroupOrMeters !== null && selectedGroupOrMeters.length > 0){
        this.setState({
          selectBy: "meterSerialNum",
          meterSerialNums: selectedGroupOrMeters,
          isContinueDisabled: false,
        });
      }
    }
  }

  validateMeters(input) {
    const { uiError } = this.state;
    const { checkForMeterExistence } = this.props;
    const meters = input.split(",");
    if(uiError === null){
      checkForMeterExistence({
      "meterGroupName": "test123",
      "meterGroupType": "STATIC",
      "meters": input.split(","),
      "query": null
    });
    }

  }

  handleChange(inputFor, text) {
    const { isMeterInvalid, resetMeterExistenceCheck, selectedGroupOrMeters, resetstep2Details } = this.props;
      if(selectedGroupOrMeters !== null) {
        resetstep2Details();
      }
    this.setState({ [inputFor]: text }, () => {
      if(inputFor === "meterSerialNums"){
        if(isMeterInvalid){
          resetMeterExistenceCheck();
        }

        if(text.length < 3){
          this.setState({
            uiError: "Serial number length should be 3 minimum",
            isContinueDisabled: true,
          });
          return;
        }

        const isInValidMeterSerialInput = validateMeterSerialInput(text);
        if (isInValidMeterSerialInput !== undefined) {
          this.setState({
            uiError: isInValidMeterSerialInput,
            isContinueDisabled: true,
          });
          return;
        }
      }

      this.setState({
        uiError: null,
        isContinueDisabled: false
      });
    });
  }

  setSelectedGroup(group) {
    this.setState({
      selectedGroup: group,
    },()=>{
      const { selectedGroupOrMeters, resetstep2Details } = this.props;
      if(selectedGroupOrMeters !== null) {
        resetstep2Details();
      }
      this.setState({
        uiError: null,
        isContinueDisabled: false
      });
    })
  }

  handleSelectByChange(selectedVal) {
    const { isMeterInvalid, resetMeterExistenceCheck, selectedGroupOrMeters, resetstep2Details } = this.props;
    if(isMeterInvalid){
      resetMeterExistenceCheck();
    }
    if(selectedGroupOrMeters !== null) {
      resetstep2Details();
    }
    this.setState({
      selectBy:selectedVal,
      uiError:null,
      selectedGroup: null,
      meterSerialNums: null,
      isContinueDisabled: true
    });
  }

  proceed() {
    const { stepper, saveStep2Details } = this.props;

    const { selectedGroupOrMeters } = this.props.newJobEntries || {};
    if(selectedGroupOrMeters !== null && selectedGroupOrMeters !== undefined){
      return stepper.resolve({});
    }

    const { selectedGroup } = this.state;
    if(selectedGroup !== null){
      saveStep2Details(selectedGroup);
      return stepper.resolve({});
    }

    //validate meters
    const { meterSerialNums, uiError } = this.state;
    const { checkForMeterExistence } = this.props;
    const meters = meterSerialNums.split(",");
    if(uiError === null){
          checkForMeterExistence({
            "meterGroupName": "test"+Math.floor(100 + Math.random() * 900),
            "meterGroupType": "STATIC",
            "meters": meters,
            "dryRun": true,
            // "query": null
          }, stepper, saveStep2Details);
        }
    // return stepper.resolve({
    // });
  }

  render() {
    const {

      stepper,
      cancelAction,
      isMeterInvalid,
      apiError

    } = this.props;

    const { selectBy, meterSerialNums, isContinueDisabled, uiError, selectedGroup } = this.state;

    return (
      <StepperContent
        loading={false}
        onSubmit={this.proceed}
        title={title}
        actions={[
          cancelAction,
          <Button raised type="submit" disabled={ isContinueDisabled || isMeterInvalid }>
            <FormattedMessage {...messages.continue} />
          </Button>,
        ]}
        className="select-meters-form-container"
      >
        <Form className={"create-job-form"}>
          {uiError && <Error><span title={uiError}>{uiError}</span></Error>}
          {isMeterInvalid && <Error><span title={apiError}>{apiError}</span></Error>}
          <div className={"select-by-container"}>
            <DisplayField label={"Select by:"} isRequired>
              <RadioField
                id={"select-by-meter-grp"}
                checked={selectBy === "meterGroup"}
                onChange = {() => this.handleSelectByChange("meterGroup")}
                label={"Meter Group"}
              />
              <RadioField
                id={"select-by-serial-num"}
                checked={selectBy === "meterSerialNum"}
                onChange = {() => this.handleSelectByChange("meterSerialNum")}
                label={"Serial Number"}
              />
            </DisplayField>
          </div>

          {
            selectBy === "meterGroup"
            ?
            <div className='group-selection-container'>
              <Groups isFromJob={true} selectedGroupForJob={selectedGroup} setSelectedGroup={this.setSelectedGroup} stepper={stepper} STEP_ID={STEP_ID}/>
            </div>
            : null
          }

          {
            selectBy === "meterSerialNum"
            ?
            <div className={"mtr-srl-nums-container"}>
              <DisplayField label={"Meter Serial Numbers (comma-separated)"} isRequired>
                <TextField
                  type="text"
                  placeholder="Enter meter serial numbers separated by commas (e.g., MTR001, MTR002, MTR003)"
                  value={ meterSerialNums }
                  onChange={(e) => this.handleChange("meterSerialNums", e.target.value)}
                  // onBlur={(e) => this.validateMeters(e.target.value)}
                  fullWidth
                />
              </DisplayField>
            </div>
            : null
          }

        </Form>
      </StepperContent>
    );
  }
}

Step2.defaultProps = {
  loadGroups: ()=>{},
  isMeterInvalid: false,
};

export default compose(
  connect(
    state => ({
      apiError: state.job.jobs.createJob.error,
      isMeterInvalid: state.job.jobs.createJob.isMeterInvalid,
      newJobEntries: state.job.jobs.createJob,
    }),
    {
      loadGroups: groupsActions.load,
      checkForMeterExistence: jobsActions.checkForMeterExistence,
      resetMeterExistenceCheck: jobsActions.resetMeterExistenceCheck,
      saveStep2Details: jobsActions.saveStep2Details,
      resetstep2Details: jobsActions.resetstep2Details,
    },
  ),
  injectIntl,
)(Step2);
